export const getResource = (name, types = []) => {
  let resourceData = [];
  try {
    resourceData = JSON.parse(localStorage.getItem("resourceAccess") || "[]");
  } catch (e) {
    resourceData = [];
  }
  const list = Array.isArray(resourceData) ? resourceData : [];
  const resource = list.find((item) => item.name === name);
  if (!resource) return false;

  const actionAliases = {
    read: ["read", "view"],
    view: ["view", "read"],
    update: ["update", "edit"],
    edit: ["edit", "update"],
    create: ["create"],
    delete: ["delete"],
    configure: ["configure"],
    export: ["export"],
    assign: ["assign"],
    access: ["access"],
  };

  // Strict mode: permission is granted only when the flag exists and is explicitly true.
  // Missing flags must not be treated as allowed.
  return (types || []).every((type) => {
    const keysToCheck = actionAliases[type] || [type];
    return keysToCheck.some((key) => resource[key] === true);
  });
};